import { MaterialReactTable } from "material-react-table";
import React, { useMemo, useState, useEffect, useRef } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Tooltip,
    Box,
    CircularProgress,
    Typography,
} from "@mui/material";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import { RemoveIcon } from "../../../assets/images";
import { Modal } from "react-bootstrap";
import AlertTemplateMessage from "../../Configuration/AlertTemplate/AlertTemplateMessage";

import VideocamIcon from "@mui/icons-material/Videocam";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import ListAltIcon from "@mui/icons-material/ListAlt";
import NetworkCheckIcon from "@mui/icons-material/NetworkCheck";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import SettingsIcon from "@mui/icons-material/Settings";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CancelIcon from "@mui/icons-material/Cancel";
import { ErrorToast } from "../../../CustomHooks/ErrorToast";
import { getDeviceInformation, getDiscoverDeviceList } from "../../../services/onVifService";
import { SuccessToast } from "../../../CustomHooks/SuccessToast";
import TableViewRoundedIcon from '@mui/icons-material/TableViewRounded';
import { addMultipleDevice, getAllFilters, getInterfaceSubTypeData, getOnBoardedDeviceList, onBoardOnVifDevice, updateOnVifDevice } from "../../../services/configurationServices";
import { useTimezone } from "../../../CustomHooks/useTimezone";
import DeviceDetails from "./DeviceDetails";

const NVRDiscover = ({ discoverList, loading }) => {
    // region useState start 
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showAdditionalModal, setShowAdditionalModal] = useState(false);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });
    const [deviceName, setDeviceName] = useState("Entrance Camera 01");
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [selectedSite, setSelectedSite] = useState("");
    const [onvifIPAddress, setOnvifIPAddress] = useState("");
    const [onvifPort, setOnvifPort] = useState("");
    const [onvifUserName, setOnvifUserName] = useState("");
    const [onvifPassword, setOnvifPassword] = useState("");
    const [timeZoneAbreviation, setTimeZoneAbreviation] = useState("");

    const [onVifIPAddressError, setOnvifIPAddressError] = useState("");
    const [onVifPortError, setOnvifPortError] = useState("");
    const [onVifUserNameError, setOnvifUserNameError] = useState("");
    const [onVifPasswordError, setOnvifPasswordError] = useState("");
    const [deviceNameError, setDeviceNameError] = useState("");
    const [tcpPortError, setTcpPortError] = useState("");
    const [cameraDetails, setCameraDetails] = useState([]);
    const [deviceInfo, setDeviceInfo] = useState(null);
    const [tcpPort, setTcpPort] = useState(8000);
    const [isTwoWayEnabled, setIsTwoWayEnabled] = useState(false);
    const [hooterTypes, setHooterTypes] = useState("");
    const [isHooterEnabled, setIsHooterEnabled] = useState(false);
    const [siteSearch, setSiteSearch] = useState("");
    const [username, setUsername] = useState("");
    const [usernameError, setUsernameError] = useState("");
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    //const [deviceInfo, setDeviceInfo] = useState(null);
    const [deviceInfoLoading, setDeviceInfoLoading] = useState(false);
    const [selectedDeviceIP, setSelectedDeviceIP] = useState(null);
    const [filterData, setFilterData] = useState([]);
    const [interfaceSubTypeData, setInterfaceSubTypeData] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState("");
    const [selectedTimeZone, setSelectedTimeZone] = useState("");
    const [interfaceUserName, setInterfaceUserName] = useState("");
    const [interfacePassword, setInterfacePassword] = useState("");
    const [selectedDeviceIds, SetSelectedDeviceIds] = useState("")
    const [interfaceUserNameError, setInterfaceUserNameError] = useState("");
    const [interfacePasswordError, setInterfacePasswordError] = useState("");
     //onBoarded data from DB
      const [onBoardedDeviceDetails, setOnBoardedDeviceDetails] = useState(null);
      const [isEditMode, setIsEditMode] = useState(false);
      const [manualOnBoard, setManualOnBoard] = useState(false);
     const user = JSON.parse(localStorage.getItem("user"));
  const UserId = user?.Id;
  const OrganizationMasterID = user?.OrganizationMasterID;

    const [devices, setDevices] = useState([]);
    // console.log("123SelectedRow", selectedRow)
    const { timezone } = useTimezone();
    
    // Track the current active modal request to prevent race condition
    const currentRequestRef = useRef(null);

    useEffect(() => {
        if (isEditMode) {
            // in edit mode we only want to show the camera that matches the onboarded device details (if any)
            let cameras = onBoardedDeviceDetails?.Cameras || [];
            cameras = cameras.filter((c) => c.ParentDeviceID !== null);

            let onBoardedCameras = cameras.map((c, idx) => {
                const liveType = c.SubTypeLive === 1 ? "Sub" : "Main";
                const playbackType = c.SubTypePlayback === 1 ? "Sub" : "Main";
                const deviceStageType = c.DeviceStageId === 2 ? "Live" : "QC Pending";

                const onvifData = cameraDetails.find(
                    (cd) => cd.channel === c.ChannelNo,
                );

                return {
                    ...c,
                    id: c.DeviceId,
                    selected: 1,
                    onboarded: true,
                    CameraName: c.Name,
                    channel: c.ChannelNo,
                    LiveStreamType: liveType,
                    PlayBackStreamType: playbackType,
                    MainRTSPURL: onvifData?.main_rtsp_uri ? generateRTSPURLWithCredentials(onvifData.main_rtsp_uri, onvifUserName,onvifPassword,) : c.RTSPCameraUrl || "",

                    SubRTSPURL: onvifData?.sub_rtsp_uri
            ? generateRTSPURLWithCredentials(
                onvifData.sub_rtsp_uri[0],
                onvifUserName,
                onvifPassword,
              )
            : c.SubRTSPurl ||"",
                    DeviceType: c.EntityType,
                    IsTranscodingEnabled: onvifData ? onvifData?.IsTranscodingEnabled : c.IsTranscodingEnabled,
                    IsPlayBackTranscodingEnabled: onvifData ? onvifData?.IsTranscodingEnabled : c.IsTranscodingEnabled,
                    IsPtz: onvifData ? onvifData?.IsPtz : c.IsPtz,
                    IsTwoWayEnabled: deviceInfo.Capabilities.Audio || 0,
                    ISPlaybackUTC: c.ISPlaybackUTC,
                    DeviceStageId: deviceStageType,
                    main_rtsp_uri: onvifData?.main_rtsp_uri || c.RTSPCameraUrl || "",
                    sub_rtsp_uri: onvifData?.sub_rtsp_uri
                                ? generateRTSPURLWithCredentials(
                                    onvifData.sub_rtsp_uri[0],
                                    onvifUserName,
                                    onvifPassword,
                                )
                                : c.SubRTSPurl ||"",
                    AlertService: c.AlertMonitoring ? 1 : 0,
                    MonitoringService: c.CCTVMonitoring ? 1 : 0,
                    HMService: c.HMMonitoring ? 1 : 0,
                    RecordingBackupService: c.CCTVRecordingBackup ? 1 : 0,
                    main_bitrate: onvifData?.main_bitrate || c.Main_Bitrate || "",
                    main_encoding: onvifData?.main_encoding || c.Main_Encoding || "",
                    main_fps: onvifData?.main_fps || c.Main_FPS || "",
                    main_resolution_width: onvifData?.main_resolution_width ? onvifData?.main_resolution_width : c.Main_Resolution ? c.Main_Resolution.split(" x ")[0] : "",
                    main_resolution_height: onvifData?.main_resolution_height ? onvifData?.main_resolution_height : c.Main_Resolution ? c.Main_Resolution.split(" x ")[1] : "",
                    sub_bitrate: Array.isArray(onvifData?.sub_bitrate) ? onvifData?.sub_bitrate[0] : c.Sub_Bitrate || "",
                    sub_fps: Array.isArray(onvifData?.sub_fps) ? onvifData?.sub_fps[0] : c.Sub_FPS || "",
                    sub_resolution_height: Array.isArray(onvifData?.sub_resolution_height) ? onvifData?.sub_resolution_height[0] : c.Sub_Resolution ? c.Sub_Resolution.split(" x ")[0] : "",
                    sub_resolution_width: Array.isArray(onvifData?.sub_resolution_width) ? onvifData?.sub_resolution_width[0]  : c.Sub_Resolution ? c.Sub_Resolution.split(" x ")[1] : "",
                    main_profile_token: onvifData?.main_profile_token || c.MainProfileToken || "",
                    main_profile_name: onvifData?.main_profile_name || c.MainProfileName || "",
                    sub_profile_name: Array.isArray(onvifData?.sub_profile_name)
                        ? onvifData?.sub_profile_name[0]
                        : c.SubProfileName || "",
                    sub_profile_token: Array.isArray(onvifData?.sub_profile_token)
                        ? onvifData?.sub_profile_token[0]
                        : c.SubProfileToken || "",
                    sub_encoding: Array.isArray(onvifData?.sub_encoding)
                        ? onvifData?.sub_encoding[0]: c.Sub_Encoding || "",

                };
            });
             let pendingCameras = cameraDetails.filter(
        (cd) => !cameras.some((c) => c.ChannelNo === cd.channel),
      );

            // console.log("pendingCameras", pendingCameras)

            if(pendingCameras.length > 0){
                const mapped = pendingCameras.map((c, idx) => {
                const liveType = c.SubTypeLive === "1" ? "Sub" : "Main";
                const playbackType = c.SubTypePlayback === "1" ? "Sub" : "Main";
                const deviceStageType = c.DeviceStageId === 2 ? "Live" : "QC Pending";

                return {
                    ...c,
                    id: c.channel,// use channel as id for pending cameras since they won't have a DeviceId until onboarded
                    selected: 1,
                    onboarded: false,
                    CameraName: c.CameraName,
                    channel: c.channel,
                    LiveStreamType: liveType,
                    PlayBackStreamType: playbackType,
                    MainRTSPURL: c.main_rtsp_uri ? generateRTSPURLWithCredentials(c.main_rtsp_uri, onvifUserName, onvifPassword) : "",
                    SubRTSPURL: Array.isArray(c.sub_rtsp_uri) ? generateRTSPURLWithCredentials(c.sub_rtsp_uri[0], onvifUserName, onvifPassword) : "",
                    DeviceType: c.DeviceType,
                    IsTranscodingEnabled: c.IsTranscodingEnabled,
                    IsPlayBackTranscodingEnabled: c.IsTranscodingEnabled,
                    IsPtz: c.IsPtz,
                    IsTwoWayEnabled: deviceInfo.Capabilities.Audio || 0,
                    ISPlaybackUTC: c.ISPlaybackUTC,
                    DeviceStageId: deviceStageType,
                    // keep original urls around so we can recalc when user changes
                    main_rtsp_uri: c.main_rtsp_uri ? generateRTSPURLWithCredentials(c.main_rtsp_uri, onvifUserName, onvifPassword) : "",
                    sub_rtsp_uri: Array.isArray(c.sub_rtsp_uri) ? generateRTSPURLWithCredentials(c.sub_rtsp_uri[0], onvifUserName, onvifPassword) : "",
                    AlertService: 1,
                    MonitoringService: 1,
                    HMService: 1,
                    RecordingBackupService: 0,
                    main_profile_token: c.main_profile_token,
                    main_profile_name: c.main_profile_name,
                    sub_profile_name: Array.isArray(c.sub_profile_name) ? c.sub_profile_name[0] : "",
                    sub_profile_token: Array.isArray(c.sub_profile_token) ? c.sub_profile_token[0] : "",
                    main_bitrate: c.main_bitrate,
                    main_encoding: c.main_encoding,
                    main_fps: c.main_fps,
                    main_resolution_width: c.main_resolution_width || "",
                    main_resolution_height: c.main_resolution_height || "",
                    sub_bitrate: Array.isArray(c.sub_bitrate) ? c.sub_bitrate[0] : "",
                    sub_encoding: Array.isArray(c.sub_encoding) ? c.sub_encoding[0] : "",
                    sub_fps: Array.isArray(c.sub_fps) ? c.sub_fps[0] : "",
                    sub_resolution_height: Array.isArray(c.sub_resolution_height) ? c.sub_resolution_height[0] : "",
                    sub_resolution_width: Array.isArray(c.sub_resolution_width) ? c.sub_resolution_width[0]: "",
                    ZoneID: selectedSite,
                    SerialNo: deviceInfo?.SerialNumber,
                };
            });

                onBoardedCameras = [...onBoardedCameras, ...mapped];
            }
            console.log("Devices set in edit mode:", devices);
            setDevices(onBoardedCameras);

        } else {
            if (!Array.isArray(cameraDetails)) return;
            const mapped = cameraDetails.map((c, idx) => {
                const liveType = c.SubTypeLive === "1" ? "Sub" : "Main";
                const playbackType = c.SubTypePlayback === "1" ? "Sub" : "Main";
                const deviceStageType = c.DeviceStageId === 2 ? "Live" : "QC Pending";

                return {
                    id: idx + 1,
                    selected: 1,
                    onboarded: false,
                    CameraName: c.CameraName,
                    channel: c.channel,
                    LiveStreamType: liveType,
                    PlayBackStreamType: playbackType,
                    MainRTSPURL: generateRTSPURLWithCredentials(c.main_rtsp_uri, onvifUserName, onvifPassword),
                    SubRTSPURL: Array.isArray(c.sub_rtsp_uri) ? generateRTSPURLWithCredentials(c.sub_rtsp_uri[0], onvifUserName, onvifPassword) : "",
                    DeviceType: c.DeviceType,
                    IsTranscodingEnabled: c.IsTranscodingEnabled,
                    IsPlayBackTranscodingEnabled: c.IsTranscodingEnabled,
                    IsPtz: c.IsPtz,
                    IsTwoWayEnabled: deviceInfo.Capabilities.Audio || 0,
                    ISPlaybackUTC: c.ISPlaybackUTC,
                    DeviceStageId: deviceStageType,
                    // keep original urls around so we can recalc when user changes
                    main_rtsp_uri: c.main_rtsp_uri,
                    sub_rtsp_uri: Array.isArray(c.sub_rtsp_uri) ? generateRTSPURLWithCredentials(c.sub_rtsp_uri[0], onvifUserName, onvifPassword) : "",
                    AlertService: 1,
                    MonitoringService: 1,
                    HMService: 1,
                    RecordingBackupService: 0,
                    main_profile_token: c.main_profile_token,
                    main_profile_name: c.main_profile_name,
                    sub_profile_name: Array.isArray(c.sub_profile_name) ? c.sub_profile_name[0] : "",
                    sub_profile_token: Array.isArray(c.sub_profile_token) ? c.sub_profile_token[0] : "",
                    main_bitrate: c.main_bitrate,
                    main_encoding: c.main_encoding,
                    main_fps: c.main_fps,
                    main_resolution_width: c.main_resolution_width || "",
                    main_resolution_height: c.main_resolution_height || "",
                    sub_bitrate: Array.isArray(c.sub_bitrate) ? c.sub_bitrate[0] : "",
                    sub_encoding: Array.isArray(c.sub_encoding) ? c.sub_encoding[0] : "",
                    sub_fps: Array.isArray(c.sub_fps) ? c.sub_fps[0] : "",
                    sub_resolution_height: Array.isArray(c.sub_resolution_height) ? c.sub_resolution_height[0] : "",
                    sub_resolution_width: Array.isArray(c.sub_resolution_width) ? c.sub_resolution_width[0]: "",
                    ZoneID: selectedSite,
                    SerialNo: deviceInfo?.SerialNumber,
                };
            });
            console.log("Devices set in non-edit mode:", devices);
            setDevices(mapped);
        }


    }, [cameraDetails]);
    const getTimeZoneValue = (tzString) => {
        // tzString examples: "GMT+05:30", "UTC-5:30", "CST-5:30:00"
        if (!tzString || !timezone) {
            return tzString;
        }

        // timezone should be an array of timezone objects (from useTimezone hook)
        const tzArray = Array.isArray(timezone) ? timezone : timezone?.TimeZones || [];

        if (tzArray.length === 0) {
            return tzString;
        }

        // Extract offset from timezone string using regex
        // Matches patterns like "+05:30", "-5:30", "-5:30:00"
        const offsetRegex = /([+-])(\d{1,2}):(\d{2})(?::(\d{2}))?/;
        const match = tzString.match(offsetRegex);

        if (!match) {
            return tzString;
        }

        const sign = match[1]; // '+' or '-'
        const hours = parseInt(match[2], 10);
        const minutes = parseInt(match[3], 10);

        // Calculate offset in minutes
        const offsetMinutes = (sign === '-' ? -1 : 1) * (hours * 60 + minutes);

        // Find matching timezone by comparing OffsetMinutes
        const matchedTz = tzArray.find((tz) => tz.OffsetMinutes === offsetMinutes);

        // Return abbreviation if found, otherwise return original string
        return matchedTz ? matchedTz.Abbreviation : tzString;
    }

    const getTimeZoneID = (Abr) => {
        if (!timezone) return null;
        const tzArray = Array.isArray(timezone) ? timezone : timezone?.TimeZones || [];
        const matchedTz = tzArray.find((tz) => tz.Abbreviation === Abr);
        return matchedTz ? matchedTz.TimeZoneID : null;
    }
    const generateRTSPURLWithCredentials = (rtspURL, username, password) => {
        // When given a plain RTSP URL and optional credentials we need to
        // inject the username/password into the authority portion of the URL.
        // The built-in URL class will handle percent-encoding for us (e.g.
        // "@" becomes "%40").
        try {
            const u = new URL(rtspURL);
            if (username) {
                u.username = username;
            }
            if (password) {
                u.password = password;
            }
            return u.toString();
        } catch (err) {
            // If parsing fails, just return the original string so callers
            // don't crash.  It might not be a valid URL.
            console.warn("generateRTSPURLWithCredentials: invalid url", rtspURL, err);
            return rtspURL;
        }
    }
    // region useState end
    // sample data for customers and sites
    const customerOptions = React.useMemo(() => {
        const uniqueCustomers = [];
        const seenIds = new Set();

        filterData.forEach((item) => {
            if (!seenIds.has(item.ClientId)) {
                uniqueCustomers.push({
                    id: item.ClientId,
                    name: item.ClientName,
                });
                seenIds.add(item.ClientId);
            }
        });

        return uniqueCustomers;
    }, [filterData]);

    // Derive site options based on selected customer
    const siteOptions = React.useMemo(() => {
        if (!selectedCustomer) return [];

        const sites = [];
        const seenIds = new Set();

        filterData.forEach((item) => {
            if (
                item.ClientId === parseInt(selectedCustomer) &&
                !seenIds.has(item.SiteID) &&
                item.SiteID !== null &&
                item.SiteName !== null
            ) {
                sites.push({
                    id: item.SiteID,
                    name: item.SiteName,
                });
                seenIds.add(item.SiteID);
            }
        });

        return sites;
    }, [selectedCustomer, filterData]);



    const data =
        discoverList && Array.isArray(discoverList)
            ? discoverList
            : [];
    const columns = useMemo(
        () => [
            {
                accessorKey: "IP",
                header: "IP",
                size: 250,
            },
            {
                accessorKey: "Port",
                header: "Port",
                size: 200,
            },
            {
                accessorKey: "Name",
                header: "Device name",
                size: 300,
            },
            // {
            //     accessorKey: "Type",
            //     header: "Type",
            //     size: 300,
            //     Cell: ({ cell }) =>
            //         Array.isArray(cell.getValue())
            //             ? cell.getValue().join(", ")
            //             : cell.getValue(),
            // },
            {
                accessorKey: "Hardware",
                header: "Hardware",
                size: 300,
            },
            {
                accessorKey: "DeviceType",
                header: "Device Type",
                size: 300,
            },
            {
                accessorKey: "Profiles",
                header: "Profiles",
                size: 300,
                Cell: ({ cell }) =>
                    Array.isArray(cell.getValue())
                        ? cell.getValue().join(", ")
                        : cell.getValue() || "-",
            },

            // {
            //     id: "actions",
            //     header: "Actions",
            //     size: 300,
            //     Cell: ({ row }) => (
            //         <Box
            //             sx={{ display: "flex", gap: "0.5rem", justifyContent: "center" }}
            //         >
            //             <Button
            //                 variant="outlined"
            //                 color="primary"
            //                 size="small"
            //                 onClick={() => showModel(row)}
            //             >
            //                 Get Additional Info
            //             </Button>
            //         </Box>
            //     ),
            //     muiTableHeadCellProps: {
            //         sx: {
            //             position: "sticky",
            //             right: 0,
            //         },
            //     },
            //     muiTableBodyCellProps: {
            //         sx: {
            //             position: "sticky",
            //             right: 0,
            //             zIndex: 2,
            //         },
            //     },
            // },
            {
                id: "actions",
                header: "Actions",
                size: 220,
                Cell: ({ row }) => (
                    <Box sx={{ display: "flex", gap: "0.5rem", justifyContent: "center" }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            onClick={() => {
                                setSelectedRow(row.original);
                                showModel(row.original);
                            }}
                            
                        >
                            Get Additional Info
                        </Button>
                    </Box>
                ),
                muiTableHeadCellProps: {
                    sx: {
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#1976d2",
                        color: "white",
                        fontWeight: "bold",
                        zIndex: 3,
                        textAlign: "center",
                    },
                },
                muiTableBodyCellProps: {
                    sx: {
                        position: "sticky",
                        right: 0,
                        zIndex: 2,
                        textAlign: "center",
                    },
                },
            },
        ],
        [],
    );

    // const showDiscoverInterfaceForm = async () => {
    //     // show both loading flags so UI can reflect discovery in progress
    //     setLoading(true);
    //     //setIsDiscoverLoading(true);
    //     const payload = {
    //         DeviceType: "NVR/DVR",
    //     }
    //     try {
    //         const response = await getDiscoverDeviceList(payload);
    //         if (response && response.Status === "success") {
    //             setDiscoverDeviceList(response.Data);
    //             SuccessToast("Device Discover Successfully");
    //             //setShowInterfaceDiscoverForm(true);
    //         } else {
    //             setDiscoverDeviceList([]);
    //             ErrorToast("Device Discover Failed");
    //         }
    //     } catch (err) {
    //         console.log(err,'JEtson');
    //         ErrorToast("Error discovering devices");
    //     } finally {
    //         //setIsDiscoverLoading(false);
    //         setLoading(false);
    //     }
    // };

    // useEffect(() => {
    //     showDiscoverInterfaceForm();
    // }, []);
    const getTCPPortDetails = (brand) => {
        const m = brand?.toLowerCase()?.trim()
        if (m === 'cp plus' || m === 'cp_plus' || m === 'cpplus') {// CP Pluss
            return 25001;
        }
        if (m === 'dahua') {// Dahua
            return 37777;
        }
        return 8000; // default port
    }
    useEffect(() => {
        if (deviceInfo && interfaceSubTypeData.length > 0) {
            console.log("deviceInfo:", deviceInfo);
            console.log("selectedSite:", selectedSite);
            const brandId = getInfeterfaceSubTypeId(deviceInfo?.Manufacturer);
            const tcpPort = getTCPPortDetails(deviceInfo?.Manufacturer);
            if(isEditMode){
        setTcpPort(onBoardedDeviceDetails?.Communicationport || tcpPort);
        setSelectedBrand(onBoardedDeviceDetails?.InterfacesubtypeId || brandId || "");
        setSelectedTimeZone(onBoardedDeviceDetails?.TimeZoneID ? onBoardedDeviceDetails.TimeZoneID.toString() : "");
        setInterfaceUserName(onBoardedDeviceDetails?.UserName || "");
        setInterfacePassword(onBoardedDeviceDetails?.Password || "");
        setDeviceName(onBoardedDeviceDetails?.InterfaceName || "");
        setIsTwoWayEnabled(deviceInfo.Capabilities.Audio  ? true : false);
        setIsHooterEnabled(deviceInfo.Capabilities.Relay ? true : false);
      }else{
        setTcpPort(tcpPort);
        setSelectedBrand(brandId || "");
        setIsTwoWayEnabled(deviceInfo.Capabilities.Audio ? true : false);
        setIsHooterEnabled(deviceInfo.Capabilities.Relay ? true : false)

      }

           // setSelectedBrand(brandId || "");
        }
    }, [deviceInfo, interfaceSubTypeData]);
    // console.log("onBoardedDeviceDetails",onBoardedDeviceDetails)
    useEffect(() => {
        if (timeZoneAbreviation && timezone && !isEditMode) {
            const tzArray = Array.isArray(timezone) ? timezone : timezone?.TimeZones || [];
            const matchedTz = tzArray.find((tz) => tz.Abbreviation === timeZoneAbreviation);
            if (matchedTz) {
                setSelectedTimeZone(matchedTz.TimeZoneId.toString());
            }
        }
    }, [timeZoneAbreviation, timezone]);

    const onSubmitBtn = async () => {
      let isValidate = false;
      if (onvifUserName == "") {
        setOnvifUserNameError("Please enter username");
        isValidate = true;
      } else {
        setOnvifUserNameError("");
      }
      if (onvifPassword == "") {
        setOnvifPasswordError("Please enter password");
        isValidate = true;
      } else {
        setOnvifPasswordError("");
      }
    if(selectedRow == null){
      if (onvifIPAddress == "") {
        setOnvifIPAddressError("Please enter IP address");
        isValidate = true;
      } else {
        setOnvifIPAddressError("");
      }
      if (onvifPort == "") {
        setOnvifPortError("Please enter port");
        isValidate = true;
      } else {
        setOnvifPortError("");
      }
    }
      if (isValidate) {
        return;
      }
     if(selectedRow == null){
    //   console.log("Manual onboarding flow - need to fetch device info with IP: ", onvifIPAddress);
      // If manual onboarding, we need to fetch device info based on user input before proceeding to onboard
      const requestId = `${onvifIPAddress}_${onvifPort}_${Date.now()}`;
      currentRequestRef.current = requestId;
      getOnBoardedDeviceInfo(onvifIPAddress, onvifPort, requestId);

    }  

        // Call the DeviceInformation API
        setDeviceInfoLoading(true);
        let IPValue = "";
    if(selectedRow == null){ // Manual onBoarding use user entered IP and port
      IPValue = onvifIPAddress ? (onvifPort && onvifPort !== "80" ? `${onvifIPAddress}:${onvifPort}` : onvifIPAddress) : "";
    }else{ //Onboarding from discovery table, use IP and Port from selected row
      IPValue = selectedRow ? selectedRow.Port == 80 ? selectedRow.IP : `${selectedRow.IP}:${selectedRow.Port}` : "";
    }
    
    // Capture current request ID to validate response is for current modal
    const currentRequest = currentRequestRef.current;
    
        try {
            const response = await getDeviceInformation(
                IPValue,
                onvifUserName,
                onvifPassword,
            );
            // Only update state if this response is for the current active modal request
            if (currentRequest !== currentRequestRef.current) {
              console.log("Ignoring response for outdated request. Current:", currentRequestRef.current, "Response for:", currentRequest);
              return;
            }
            
            if (response && response.Status === "success") {
                setDeviceInfo(response.Data);
                setCameraDetails(response.Data.Cameras || []);
                setTimeZoneAbreviation(getTimeZoneValue(response.Data.Timezone));

                 if (selectedRow == null) {
          setDeviceName(`${response.Data.Manufacturer || "Unknown"} - ${IPValue}`);
        } else {
          if (selectedRow.Name) {
            setDeviceName(`${selectedRow.Name} - ${selectedRow?.IP}`);
          } else {
            setDeviceName("Not Available");
          }
        }
                //setDeviceName(selectedRow.Name || "Not Available");
                SuccessToast("Device information fetched successfully");
            } else {
                if (selectedRow?.Name) {
                    setDeviceName(`${selectedRow.Name} - ${selectedRow?.IP}`);
                } else {
                    setDeviceName("Not Available");
                }
                //setDeviceName(selectedRow.Name || "Not Available");
                setCameraDetails([]);
                setDeviceInfo(null);
                ErrorToast("Failed to fetch device information");
            }
        } catch (err) {
            // Only process error if this request is still current
            if (currentRequest !== currentRequestRef.current) {
              console.log("Ignoring error for outdated request:", currentRequest);
              return;
            }
            
            console.log(err);
            setDeviceInfo(null);
            setCameraDetails([]);
            ErrorToast("Error fetching device information");
        } finally {
            setDeviceInfoLoading(false);
        }
    };

    const onCloseBtn = () => {
        // Clear request ID to prevent any pending API responses from updating state
        currentRequestRef.current = null;
        
        setSelectedRow(null);
        setDeviceInfo(null);
        setOnvifUserName("");
        setOnvifIPAddress("");
        setOnvifPort("");
        setOnvifPassword("");
        setOnvifUserNameError("");
        setOnvifPasswordError("");
        setOnvifIPAddressError("");
        setOnvifPortError("");
        setDeviceNameError("");
        setShowAdditionalModal(false);
        setSelectedCustomer("");
        setSelectedSite("");
        setSelectedBrand("");
        setFilterData([]);
        setDeviceName("");
        setSelectedTimeZone("");
        setHooterTypes("");
        setIsHooterEnabled(false);
        setTimeZoneAbreviation("");
        //setIsExternalHooterEnabled(false);
        setIsTwoWayEnabled(false);
        setCameraDetails([]);
        setInterfacePassword("");
        setInterfaceUserName("");
        setTcpPort(8000);
        setDevices([]);
        setIsEditMode(false);
    };
    const showModel = async (row) => {
         const InterfaceIP = row?.IP || "";
         const InterfaceProtocolPort = Number(row?.Port);
         
         // Generate unique request ID for this modal open and store it
         const requestId = `${InterfaceIP}_${InterfaceProtocolPort}_${Date.now()}`;
         currentRequestRef.current = requestId;
         
        setShowAdditionalModal(true);

        getAllFilters({ Entity: "Interface" })
            .then((response) => {
                if (response && response.Status === "success") {
                    setFilterData(response.Data);
                } else {
                    setFilterData([]);
                }
            })
            .catch((err) => {
                console.log("Error fetching filters: ", err);
                setFilterData([]);
            });

        //fetch master data
        let obj = {
            type: "interfacesubtypemaster",
            parameters: {
                InterfacetypeId: 1,
            },
        };
        getInterfaceSubTypeData(obj).then((response) => {
            if (response && response.Status === "success") {
                setInterfaceSubTypeData(response.Data);
            } else {
                setInterfaceSubTypeData([]);
            }
        });


  if(InterfaceIP){
      getOnBoardedDeviceInfo(InterfaceIP, InterfaceProtocolPort, requestId);
    }
        console.log()


    };


    // update device name in the devices table
    const handleDeviceNameChange = (id, newName) => {
        setDevices(devices.map(device =>
            device.id === id ? { ...device, CameraName: newName } : device
        ));
    };

    // toggle checkbox for boolean fields
    const handleCheckboxChange = (id, field) => {
        setDevices(devices.map(device =>
            device.id === id ? { ...device, [field]: device[field] ? 0 : 1 } : device
        ));
    };


    const getCameraDetailsForOnboarding = () => {
        // if devices array is empty, fallback to streaming info as before
        if (!devices || devices.length === 0) {
            return []
        }

        const selectedDevices = devices.filter((device) => device.selected === 1)

        // map each device row to payload structure
        return selectedDevices.map((d) => {
            console.log("Device d in getCameraDetailsForOnboarding:", d);
            const payload = {
            CameraName: d.CameraName,
            ChannelNo: d.channel.toString(),
            // use numeric codes if system expects 0/1 for main/sub
            SubTypeLive: d.LiveStreamType === "Main" ? "0" : "1",
            SubTypePlayback: d.PlayBackStreamType === "Main" ? "0" : "1",
            RTSPURL: d.LiveStreamType === "Main" ? d.MainRTSPURL : d.SubRTSPURL,
            IsTranscodingEnabled: d.IsTranscodingEnabled || 0,
            IsPlayBackTranscodingEnabled: d.IsTranscodingEnabled || 0,
            IsPtz: d.IsPtz || 0,
            isTwoWayEnabled: d.IsTwoWayEnabled || 0,
            cctvHooterEnabledFlag: isHooterEnabled ? "1" : "0",
            ISPlaybackUTC: d.ISPlaybackUTC || 0,
            DeviceStageId: d.DeviceStageId === "Live" ? 2 : 1,
            AlertService: d.AlertService || 0,
            MonitoringService: d.MonitoringService || 0,
            HMService: d.HMService || 0,
            RecordingBackupService: d.RecordingBackupService || 0,
            CCTVTypeID: 6,
            Isonvif: 1,
            main_profile_token: d.main_profile_token || "",
            main_profile_name: d.main_profile_name || "",
            sub_profile_token: Array.isArray(d.sub_profile_token) ? d.sub_profile_token[0] : d.sub_profile_token || "",
            sub_profile_name: Array.isArray(d.sub_profile_name) ? d.sub_profile_name[0] : d.sub_profile_name || "",
            Main_Bitrate: d.main_bitrate ? d.main_bitrate.toString() : "",
            Main_Encoding: d.main_encoding,
            Main_FPS: d.main_fps ? d.main_fps.toString() : "",
            Main_Resolution: d.main_resolution_width && d.main_resolution_height ? `${d.main_resolution_width} x ${d.main_resolution_height}` : "",
            Sub_Bitrate: d.sub_bitrate ? d.sub_bitrate.toString() : "",
            Sub_FPS:  d.sub_fps ? d.sub_fps.toString() : "",
            Sub_Resolution: d.sub_resolution_width && d.sub_resolution_height ? `${d.sub_resolution_width} x ${d.sub_resolution_height}` : "",
            Sub_Encoding: d.sub_encoding,
            SubRTSPurl:d.sub_rtsp_uri || "",
            SiteId: d.ZoneID,
            SerialNo: d.SerialNo,
            };
            console.log("Payload for device in getCameraDetailsForOnboarding:", payload);
            return payload;
        });
    };

    const getInfeterfaceSubTypeId = (manufacturer) => {
        // console.log("Finding interface subtype for manufacturer: ", manufacturer);
        // If manufacturer is empty/undefined/null treat as unknown
        if (!manufacturer) {
            const unk = interfaceSubTypeData.find(
                (item) => item.Interfacesubtypename.toLowerCase() === "unknown",
            );
            return unk ? unk.InterfacesubtypeId : null;
        }
        // return InterfacesubtypeId matching given manufacturer string
        if (!interfaceSubTypeData || interfaceSubTypeData.length === 0) {
            return null;
        }
        const m = manufacturer.toLowerCase().trim();
        // try to find subtype whose name matches or contains manufacturer
        let found = interfaceSubTypeData.find((item) => {
            const name = item.Interfacesubtypename.toLowerCase().trim();
            // First try exact match or substring match
            if (name === m || name.includes(m) || m.includes(name)) {
                return true;
            }
            // Then try normalized match (remove spaces)
            const normalizedM = m.replace(/\s+/g, '');
            const normalizedName = name.replace(/\s+/g, '');
            return normalizedName === normalizedM || normalizedName.includes(normalizedM) || normalizedM.includes(normalizedName);
        });
        if (!found) {
            // fallback: look for ONVIF
            found = interfaceSubTypeData.find(
                (item) => item.Interfacesubtypename.toLowerCase() === "onvif",
            );
        }
        return found ? found.InterfacesubtypeId : null;
    };

    const validateForm = () => {
        let isValid = true;
        let deviceNameErr = "";
        let tcpPortErr = "";
        let interfaceUserNameErr = "";
        let interfacePasswordErr = "";


        if (!deviceName || deviceName.trim() === "") {
            deviceNameErr = "Device Name cannot be empty";
            isValid = false;
        }

        if (!tcpPort || isNaN(tcpPort) || tcpPort <= 0) {
            tcpPortErr = "TCP Port must be a positive number";
            isValid = false;
        }
        // if (!interfaceUserName || interfaceUserName.trim() === "") {
        //     interfaceUserNameErr = "Interface username cannot be empty";
        //     isValid = false;
        // }
        // if (!interfacePassword || interfacePassword.trim() === "") {
        //     interfacePasswordErr = "Interface password cannot be empty";
        //     isValid = false;
        // }


        setDeviceNameError(deviceNameErr);
        setTcpPortError(tcpPortErr);
        setInterfaceUserNameError(interfaceUserNameErr);
        setInterfacePasswordError(interfacePasswordErr);

        return { isValid, deviceNameErr, tcpPortErr, interfaceUserNameErr, interfacePasswordErr };
    }
    const onBoardDevice = async () => {
        const { isValid, deviceNameErr, tcpPortErr, interfaceUserNameErr, interfacePasswordErr } = validateForm();

        if (!isValid) {
        const errorMessages = [deviceNameErr, tcpPortErr, interfaceUserNameErr, interfacePasswordErr]
        .filter(Boolean)
        .map((msg, index) => <li key={index}>{msg}</li>);

        ErrorToast(
        <div>
            <p>Please fix the following validation errors before onboarding device:</p>
            <ul>{errorMessages}</ul>
        </div>
        );
            // ErrorToast("Please fix below validation errors before onboarding device\n" + errorMessages);
            return;
        }
         if(isEditMode){
      
      let deviceToAdd = devices.filter(d => d.selected === 1 && d.onboarded === false) || [];
      let deviceToUpdate = devices.filter(d => d.selected === 1 && d.onboarded === true) || [];

      console.log("deviceToAdd:", deviceToAdd);
      console.log("deviceToUpdate:", deviceToUpdate);

      await updateDevice(deviceToUpdate);
      await addDevice(deviceToAdd);
      
      return;
    }
        

        const user = JSON.parse(localStorage.getItem("user"));
        const UserId = user?.Id;
        const OrganizationMasterID = user?.OrganizationMasterID;

        let entityTypeId = 0;

        if (selectedRow?.DeviceType === "NVR") {
            entityTypeId = 4;
        } else if (selectedRow?.DeviceType === "DVR") {
            entityTypeId = 5;
        }
        const payload = {
            InterfaceName: deviceName,
            InterfacetypeId: 1,
            InterfacesubtypeId: selectedBrand,
            InterfaceIP:  manualOnBoard ? onvifIPAddress : selectedRow?.IP || "",
            InterfacePort: deviceInfo.NetworkInfo.RTSPPort?.toString() || '',
            UserName: interfaceUserName || "",
            Password: interfacePassword || "",
            siteid: parseInt(selectedSite) || null,
            isTwoWayEnabled: isTwoWayEnabled ? "1" : "0",
            isHooterEnabled: isHooterEnabled ? "1" : "0",
            CheckInternalHooter: "0",
            CheckExternalHooter: isHooterEnabled ? "1" : "0",
            LiveRTSPURL: "",
            PlaybackRTSPURL: "",
            CheckPlaybackUTCTime: "0",
            CheckPlaybackLongTime: "0",
            EntityTypeID: entityTypeId.toString(),
            TimeZoneID: selectedTimeZone || '1',
            OrganizationMasterID: OrganizationMasterID,
            UpdatedateTime: "",
            Communicationport: tcpPort.toString(),
            InternetProtocolPort: deviceInfo?.NetworkInfo?.HTTPPort || "",
            UserId: UserId,
            Onvifusername: onvifUserName,
            onvifuserpassword: onvifPassword,
            Firmware: deviceInfo?.Firmware || "",
            Profiles: selectedRow?.Profiles?.toString() || "",
            SerialNo: deviceInfo?.SerialNumber || "",
            UserID: UserId,
            Isonvif: 1,
            cameras: getCameraDetailsForOnboarding(),
        };

        onBoardOnVifDevice(payload).then((response) => {
            if (response && response.Status === "success") {
                SuccessToast("Onvif device onboarded successfully");
                onCloseBtn();
            } else {
                ErrorToast(response.Message);
            }
        }).catch((err) => {
            ErrorToast("Error onboarding Onvif device");
            console.error("Error onboarding Onvif device: ", err);
        });
        // console.log("Payload for onboarding: ", payload);
    };
    // handle Live Stream Type change
    const handleLiveStreamTypeChange = (id, newValue) => {
        setDevices(
            devices.map((device) =>
                device.id === id ? { ...device, LiveStreamType: newValue } : device,
            ),
        );
    };

    // handle Playback Stream Type change
    const handlePlayBackStreamTypeChange = (id, newValue) => {
        setDevices(
            devices.map((device) =>
                device.id === id ? { ...device, PlayBackStreamType: newValue } : device,
            ),
        );
    };
    // handle Device Stage change
    const handleDeviceStageChange = (id, newValue) => {
        setDevices(
            devices.map((device) =>
                device.id === id ? { ...device, DeviceStageId: newValue } : device,
            ),
        );
    };

    const hasData = (data) => {
    if (Array.isArray(data)) return data.length > 0;
    if (data && typeof data === "object") return Object.keys(data).length > 0;
    return false;
    };
    
    const getOnBoardedDeviceInfo = async (InterfaceIP, InterfaceProtocolPort, requestId = null, shouldUpdateState = true) => {
        const user = JSON.parse(localStorage.getItem("user"));
        const payload = {
          UserID: user?.Id,
          InterfaceIP: InterfaceIP,
          InterfaceProtocolPort: InterfaceProtocolPort
        }
        try {
          const response = await getOnBoardedDeviceList(payload);
          if (requestId && requestId !== currentRequestRef.current) {
            console.log("Ignoring response for outdated request:", requestId);
            return null;
          }
          
          if (response && response.Status === "success" && hasData(response.Data)) {
            setOnBoardedDeviceDetails(response.Data);
            if (shouldUpdateState) {
              setOnvifUserName(response.Data?.onvifusername || "");
              setOnvifPassword(response.Data?.onvifuserpassword || "");
              setSelectedCustomer(response.Data?.ClientId ? response.Data.ClientId.toString() : "");
              setSelectedSite(response.Data?.SiteID ? response.Data.SiteID.toString() : "");
              setSelectedBrand(response.Data?.InterfacesubtypeId ? response.Data.InterfacesubtypeId : "");
              //setSelectedTimeZone(response.Data?.TimeZoneID ? response.Data.TimeZoneID.toString() : "");
              setIsEditMode(true);
            }
            return response.Data;
          }
          return null;
        } catch (err) {
          // Only process error if this request is still current
          if (requestId && requestId !== currentRequestRef.current) {
            console.log("Ignoring error for outdated request:", requestId);
            return null;
          }
          if (shouldUpdateState) {
            setIsEditMode(false);
          }
          console.log(err);
          return null;
        }
    
    
      }
      useEffect(() => {
          if(onvifUserName && onvifPassword && isEditMode){
            onSubmitBtn();
          }
        }, [onvifUserName, onvifPassword]);

      const getCameraDetailsForUpdate = (updateCameraData) => {
    // For update we need to include the DeviceId for existing cameras so backend knows which ones to update vs create
    if (!updateCameraData || updateCameraData.length === 0) {
      return [];
    }
    return updateCameraData.filter((d) => d.onboarded).map((d) => ({
      DeviceId: d.id,
      ParentDeviceID: d?.ParentDeviceID || null,
      ExternalId: "",
      Description: "",
      Metadata: "",
      DeviceTypeID: d.DeviceTypeID || "",
      Lat: d.Lat || 0,
      Long: d.Long || 0,
      Altitude: d.Altitude || 0,
      SiteId: d.ZoneID || parseInt(selectedSite) || onBoardedDeviceDetails?.SiteID || onBoardedDeviceDetails?.ParentSiteID || null,
      InterfaceId: d.InterfaceId || onBoardedDeviceDetails?.InterfaceId || null,
      Name: d.CameraName || "",
      InternetProtocolPort: d.InternetProtocolPort || deviceInfo?.NetworkInfo?.HTTPPort?.toString() || "",
      isTwoWayEnabled: d.IsTwoWayEnabled ? true : false,
      cctvHooterEnabledFlag: isHooterEnabled ? "1" : "0",
      Communicationport: tcpPort.toString(),
      OrganizationMasterID: d.OrganizationMasterID || null,
      TimeZoneID: selectedTimeZone ? parseInt(selectedTimeZone) : onBoardedDeviceDetails?.TimeZoneID || 0,
      CreatedOn: "",
      ModifiedON: "",
      CreatedBy: "",
      ModifiedBy: user?.Id || null,
      UpdatedateTime: "",
      CameraId: d.id,
      CameraGuid: "",
      IsPtz: d.IsPtz || 0,
      CameraIp: d.CameraIp || onBoardedDeviceDetails?.InterfaceIP || "",
      CameraPort: d.CameraPort || deviceInfo?.NetworkInfo?.RTSPPort?.toString() || deviceInfo?.NetworkInfo?.HTTPPort?.toString() || "",
      CamUser: interfaceUserName || "",
      CamPassword: interfacePassword || "",
      ChannelNo: d.ChannelNo || "",
      RTSPCameraUrl:  d.LiveStreamType === "Main" ? (d.MainRTSPURL || d.SubRTSPURL || d.main_rtsp_uri || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "")) : (d.SubRTSPURL || d.MainRTSPURL || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "") || d.main_rtsp_uri || ""),
      RTSPURL: d.LiveStreamType === "Main" ? (d.MainRTSPURL || d.SubRTSPURL || d.main_rtsp_uri || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "")) : (d.SubRTSPURL || d.MainRTSPURL || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "") || d.main_rtsp_uri || ""),
      CCTVTypeID: d.CCTVTypeID || 6,
      PlayBackChannelNum: d.PlaybackChannelNum || null,
      IsPlayBackTranscodingEnabled: d.IsTranscodingEnabled || 0,
      IsTranscodingEnabled: d.IsTranscodingEnabled || 0,
      SubTypeLive: d.LiveStreamType === "Main" ? "0" : "1",
      SubTypePlayback: d.PlayBackStreamType === "Main" ? "0" : "1",
      ISPlaybackUTC: d.ISPlaybackUTC || 0,
      HLSStreamingURL: d.HLSStreamingURL || null,
      DeviceStageId: d.DeviceStageId === "Live" ? 2 : 1,
      AlertService: d.AlertService || 0,
      MonitoringService: d.MonitoringService || 0,
      HMService: d.HMService || 0,
      RecordingBackupService: d.RecordingBackupService || 0,
      SerialNo: d.SerialNo || deviceInfo?.SerialNumber || onBoardedDeviceDetails?.SerialNo || onBoardedDeviceDetails?.SerialNumber || "",
      UserID: user?.Id || null,
      MainProfileToken: d.main_profile_token || d.MainProfileToken || "",
      MainProfileName: d.main_profile_name || d.MainProfileName || "",
      SubProfileToken: d.sub_profile_token || d.SubProfileToken || "",
      SubProfileName: d.sub_profile_name || d.SubProfileName || "",
      Isonvif: 1,
      Main_Bitrate: d.main_bitrate ? d.main_bitrate.toString() : d.Main_Bitrate || "",
      Main_Encoding: d.main_encoding || d.Main_Encoding || "",
      Main_FPS: d.main_fps ? d.main_fps.toString() : d.Main_FPS ||"",
      Main_Resolution: d.main_resolution_width && d.main_resolution_height ? `${d.main_resolution_width} x ${d.main_resolution_height}` : d.Main_Resolution || "",
      Sub_Bitrate: d.sub_bitrate ? d.sub_bitrate.toString() : d.Sub_Bitrate ||"",
      Sub_FPS:  d.sub_fps ? d.sub_fps.toString() : d.Sub_FPS ||"",
      Sub_Resolution: d.sub_resolution_width && d.sub_resolution_height ? `${d.sub_resolution_width} x ${d.sub_resolution_height}` : d.Sub_Resolution || "",
      Sub_Encoding: d.sub_encoding || d.Sub_Encoding || "",
      SubRTSPurl:d.sub_rtsp_uri || d.SubRTSPURL || ""
    }));
  };
  const addDevice = async (deviceToAdd) => {
    if(deviceToAdd.length === 0){
      return [];
    }

    console.log("Devices to onboard: ", deviceToAdd);

    let zerochanelDevices = onBoardedDeviceDetails?.Cameras?.find((d) => d.ParentDeviceID === null) || onBoardedDeviceDetails;
    let latestDeviceDetails = onBoardedDeviceDetails;
    
    if(!zerochanelDevices){
      const fetchedDeviceData = await getOnBoardedDeviceInfo(onvifIPAddress, onvifPort, null, false);
      if (fetchedDeviceData) {
        latestDeviceDetails = fetchedDeviceData;
        zerochanelDevices = fetchedDeviceData?.Cameras?.find((d) => d.ParentDeviceID === null);
      }
    }

    const newParentDeviceId = zerochanelDevices?.DeviceId || latestDeviceDetails?.InterfaceId || null;
    const zeroChannelSiteId = latestDeviceDetails?.ParentSiteID || parseInt(selectedSite) || latestDeviceDetails?.SiteID || null;
    const zeroChannelSerial = deviceInfo?.SerialNumber || latestDeviceDetails?.SerialNo || latestDeviceDetails?.SerialNumber || "";
    console.log("zerochanelDevices", zerochanelDevices)

    deviceToAdd.forEach((d) => {  console.log("Processing device for addition: ", d)});
    const addPayload = deviceToAdd.map((d) => ({
      ParentDeviceID: newParentDeviceId,
      ExternalId: "",
      Description: "",
      Metadata: "",
      DeviceTypeID:6,
      Lat: zerochanelDevices?.Lat || 0,
      Long: zerochanelDevices?.Long || 0,
      Altitude: zerochanelDevices?.Altitude || 0,
      SiteId: zerochanelDevices?.ZoneID || zeroChannelSiteId,
      InterfaceId: latestDeviceDetails?.InterfaceId || null,
      Name: d.CameraName || "",
      InternetProtocolPort: deviceInfo?.NetworkInfo?.HTTPPort?.toString() || "",
      isTwoWayEnabled: d.IsTwoWayEnabled || 0,
      cctvHooterEnabledFlag: isHooterEnabled ? "1" : "0",
      Communicationport: tcpPort.toString(),
      OrganizationMasterID: OrganizationMasterID,
      TimeZoneID: selectedTimeZone ? parseInt(selectedTimeZone) : 0,
      CreatedOn: "",
      ModifiedON: "",
      CreatedBy: user?.Id || null,
      ModifiedBy: "",
      UpdatedateTime: "",
      CameraId: 0,
      CameraGuid: "",
      IsPtz: d.IsPtz || 0,
      CameraIp: onBoardedDeviceDetails?.InterfaceIP || "",
      CameraPort: deviceInfo?.NetworkInfo?.RTSPPort?.toString() || deviceInfo?.NetworkInfo?.HTTPPort?.toString() || "",
      CamUser: interfaceUserName || "",
      CamPassword: interfacePassword || "",
      ChannelNo: d.channel.toString(),
      CCTVTypeID: 6,
      RTSPCameraUrl: d.LiveStreamType === "Main" ? (d.MainRTSPURL || d.SubRTSPURL || d.main_rtsp_uri || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "")) : (d.SubRTSPURL || d.MainRTSPURL || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "") || d.main_rtsp_uri || ""),
      RTSPURL: d.LiveStreamType === "Main" ? (d.MainRTSPURL || d.SubRTSPURL || d.main_rtsp_uri || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "")) : (d.SubRTSPURL || d.MainRTSPURL || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "") || d.main_rtsp_uri || ""),
      PlayBackChannelNum: 1,
      SubTypeLive: d.LiveStreamType === "Main" ? "0" : "1",
      SubTypePlayback: d.PlayBackStreamType === "Main" ? "0" : "1",
      IsTranscodingEnabled: d.IsTranscodingEnabled || 0,
      IsPlayBackTranscodingEnabled: d.IsTranscodingEnabled || 0,
      ISPlaybackUTC: d.ISPlaybackUTC || 0,
      HLSStreamingURL: null,
      DeviceStageId: d.DeviceStageId === "Live" ? 2 : 1,
      AlertService: d.AlertService || 0,
      MonitoringService: d.MonitoringService || 0,
      HMService: d.HMService || 0,
      RecordingBackupService: d.RecordingBackupService || 0,
      SerialNo: zeroChannelSerial,
      UserID: user?.Id || null,
      Isonvif: 1,
      MainProfileToken: d.main_profile_token || d.MainProfileToken || "",
      MainProfileName: d.main_profile_name || d.MainProfileName || "",
      SubProfileToken: d.sub_profile_token || d.SubProfileToken || "",
      SubProfileName: d.sub_profile_name || d.SubProfileName || "",
      Main_Bitrate: d.main_bitrate ? d.main_bitrate.toString() : d.Main_Bitrate ||"",
      Main_Encoding: d.main_encoding || d.Main_Encoding || "",
      Main_FPS: d.main_fps ? d.main_fps.toString() : d.Main_FPS ||"",
      Main_Resolution: d.main_resolution_width && d.main_resolution_height ? `${d.main_resolution_width} x ${d.main_resolution_height}` : d.Main_Resolution || "",
      Sub_Bitrate: d.sub_bitrate ? d.sub_bitrate.toString() : d.Sub_Bitrate ||"",
      Sub_FPS:  d.sub_fps ? d.sub_fps.toString() : d.Sub_FPS ||"",
      Sub_Resolution: d.sub_resolution_width && d.sub_resolution_height ? `${d.sub_resolution_width} x ${d.sub_resolution_height}` : d.Sub_Resolution || "",
      Sub_Encoding: d.sub_encoding || d.Sub_Encoding || "",
      SubRTSPurl:d.sub_rtsp_uri || d.SubRTSPURL || ""
    }));

    const finalPayload = {
      "cameras": addPayload
    }
    console.log("Devices to onboard:1",finalPayload)
    addMultipleDevice(finalPayload).then((response) => {
      if(response && response.Status === "success"){
        SuccessToast("New Onvif device onboarded successfully");
        onCloseBtn();
      }
      else{
        ErrorToast(response.Message);
      }
    }).catch((err) => {
      ErrorToast("Error onboarding Onvif device");
      console.error("Error onboarding Onvif device: ", err);
    });

    

  };
  
  const updateDevice = async (updateCameraData) => {
    // Similar to onBoardDevice but calls update API and handles payload differences for update vs create
    // For simplicity, we'll just show an alert here

    const updatePayload = {
      InterfaceId: onBoardedDeviceDetails?.InterfaceId?.toString(),
      InterfaceName: deviceName,
      InterfacetypeId: 1,
      InterfacesubtypeId: selectedBrand,
      InterfaceIP: manualOnBoard ? onvifIPAddress : selectedRow?.IP || "",
      InterfacePort: deviceInfo.NetworkInfo.RTSPPort?.toString() || '',
      UserName: interfaceUserName || "",
      Password: interfacePassword || "",
      siteid: parseInt(selectedSite) || null,
      isTwoWayEnabled: isTwoWayEnabled ? "1" : "0",
      isHooterEnabled: isHooterEnabled  ? "1" : "0",
      CheckInternalHooter: "0",
      CheckExternalHooter: isHooterEnabled  ? "1" : "0",
      LiveRTSPURL: "",
      PlaybackRTSPURL: "",
      CheckPlaybackUTCTime: "0",
      CheckPlaybackLongTime: "0",
      EntityTypeID: "6",
      TimeZoneID: selectedTimeZone || '1',
      OrganizationMasterID: OrganizationMasterID,
      UpdatedateTime: "",
      Communicationport: tcpPort.toString(),
      InternetProtocolPort: deviceInfo?.NetworkInfo?.HTTPPort || "",
      UserId: UserId,
      SerialNo: deviceInfo?.SerialNumber || onBoardedDeviceDetails?.SerialNo || "",
      UserID: UserId,
      onvifusername: onvifUserName,
      onvifuserpassword: onvifPassword,
      Firmware: deviceInfo?.Firmware || "",
      profiles: selectedRow?.Profiles?.toString() || "",
      Isonvif: 1,
      cameras: getCameraDetailsForUpdate(updateCameraData),
    };

    // console.log("Update payload: ", updatePayload);
    try {
        const res = await updateOnVifDevice(updatePayload);
        if (res && res.Status === "success") {
            onCloseBtn();
            SuccessToast("Device Details updated successfully");
        } else {
            ErrorToast(`Error while updating - ${res.Message}`);
        }
    } catch (err) {
        console.log(err);
        ErrorToast("Unable to update Device Details");
    }

    
  }

    // columns for devices material react table
    const deviceColumns = useMemo(
        () => [
            {
                accessorKey: "CameraName",
                header: "Camera Name",
                size: 200,
                Cell: ({ cell, row }) => (
                    <input
                        type="text"
                        value={cell.getValue()}
                        onChange={(e) => handleDeviceNameChange(row.original.id, e.target.value)}
                        style={{
                            border: "1px solid #ccc",
                            padding: "4px 6px",
                            borderRadius: "3px",
                            width: "95%",
                            background: "transparent",
                        }}
                    />
                ),
            },
            {
                accessorKey: "ChannelNo",
                header: "Channel No",
                size: 200,
            },
            {
                accessorKey: "LiveStreamType",
                header: "Live Stream Type",
                size: 200,
                Cell: ({ cell, row }) => (
                    <select
                        value={cell.getValue()}
                        onChange={(e) =>
                            handleLiveStreamTypeChange(row.original.id, e.target.value)
                        }
                        style={{
                            border: "1px solid #ccc",
                            padding: "4px 6px",
                            borderRadius: "3px",
                            width: "95%",
                            background: "transparent",
                        }}
                    >
                        <option value="Main">Main</option>
                        <option value="Sub">Sub</option>
                    </select>
                ),
            },
            {
                accessorKey: "PlayBackStreamType",
                header: "Playback Stream Type",
                size: 200,
                Cell: ({ cell, row }) => (
                    <select
                        value={cell.getValue()}
                        onChange={(e) =>
                            handlePlayBackStreamTypeChange(row.original.id, e.target.value)
                        }
                        style={{
                            border: "1px solid #ccc",
                            padding: "4px 6px",
                            borderRadius: "3px",
                            width: "95%",
                            background: "transparent",
                        }}
                    >
                        <option value="Main">Main</option>
                        <option value="Sub">Sub</option>
                    </select>
                ),
            },
            {
                accessorKey: "RTSPURL",
                header: "RTSP URL",
                size: 300,
                Cell: ({ cell }) => (
                    <span style={{ wordBreak: "break-all", fontSize: "12px" }}>
                        {cell.getValue()}
                    </span>
                ),
            },
            {
                accessorKey: "DeviceType",
                header: "Device Type",
                size: 200,
            },
            {
                accessorKey: "IsTranscodingEnabled",
                header: "Transcoding",
                size: 200,
                Cell: ({ row }) => (
                    <input
                        type="checkbox"
                        checked={row.original.IsTranscodingEnabled ? true : false}
                        onChange={() =>
                            handleCheckboxChange(row.original.id, "IsTranscodingEnabled")
                        }
                    />
                ),
            },
            {
                accessorKey: "IsPlayBackTranscodingEnabled",
                header: "Playback Transcoding",
                size: 200,
                Cell: ({ row }) => (
                    <input
                        type="checkbox"
                        checked={row.original.IsPlayBackTranscodingEnabled ? true : false}
                        onChange={() =>
                            handleCheckboxChange(
                                row.original.id,
                                "IsPlayBackTranscodingEnabled",
                            )
                        }
                    />
                ),
            },
            {
                accessorKey: "IsPtz",
                header: "PTZ",
                size: 120,
                Cell: ({ row }) => (
                    <input
                        type="checkbox"
                        checked={row.original.IsPtz ? true : false}
                        onChange={() => handleCheckboxChange(row.original.id, "IsPtz")}
                    />
                ),
            },
            {
                accessorKey: "IsTwoWayEnabled",
                header: "Two Way",
                size: 150,
                Cell: ({ row }) => (
                    <input
                        type="checkbox"
                        checked={row.original.IsTwoWayEnabled ? true : false}
                        onChange={() =>
                            handleCheckboxChange(row.original.id, "IsTwoWayEnabled")
                        }
                    />
                ),
            },
            {
                accessorKey: "ISPlaybackUTC",
                header: "Playback UTC",
                size: 200,
                Cell: ({ row }) => (
                    <input
                        type="checkbox"
                        checked={row.original.ISPlaybackUTC ? true : false}
                        onChange={() =>
                            handleCheckboxChange(row.original.id, "ISPlaybackUTC")
                        }
                    />
                ),
            },
            {
                accessorKey: "DeviceStageId",
                header: "Device Stage",
                size: 200,
                Cell: ({ cell, row }) => (
                    <select
                        value={cell.getValue()}
                        onChange={(e) =>
                            handleDeviceStageChange(row.original.id, e.target.value)
                        }
                        style={{
                            border: "1px solid #ccc",
                            padding: "4px 6px",
                            borderRadius: "3px",
                            width: "95%",
                            background: "transparent",
                        }}
                    >
                        <option value="Live">Live</option>
                        <option value="QC Pending">QC Pending</option>
                    </select>
                ),
            },

        ],
        [devices]
    );

    return (
        <>
            {/* <div className="p-2 d-flex align-items-center gap-2">
                <button
                    style={{ background: "#1268ce", borderRadius: "4px" }}
                    title="Go back"
                    onClick={() => setShowInterfaceDiscoverForm(false)}
                >
                    <ArrowBackIosRoundedIcon className="w-5 h-5 text-white" />
                </button>
                <Typography variant="h6" sx={{ fontWeight: 600, ml: 0.5 }}>
                    Discover Devices configuration
                </Typography>

                <Box sx={{ flex: 1 }} />

                <Button
                    variant="outlined"
                    size="small"
                    onClick={showDiscoverInterfaceForm}
                    disabled={loading}
                >
                    Refresh
                </Button>
            </div> */}

            <div>
                {loading ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            minHeight: 'calc(100vh - 300px)',
                            flexDirection: 'column',
                        }}
                    >
                        <CircularProgress size={60} thickness={4} />
                        <Box mt={2}>
                            <span style={{ fontSize: '16px', color: '#666' }}>
                                Discovering Onvif supported devices on your network...This may take some while. Please wait.
                            </span>
                        </Box>
                    </Box>
                ) : (
                    <div
                        className="col-lg-12 mb-1 m-0 TabulerReportMainDiv MatReactTableDiv"
                        style={{ height: "calc(100vh - 245px)" }}
                    >
                        {/* <MaterialReactTable
                            columns={columns}
                            data={data}
                            initialState={{ showColumnFilters: false }}
                            enableGlobalFilter={true}
                            enableColumnFilters={false}
                            enableStickyHeader
                            enableColumnResizing={true}
                            globalFilterFn="contains"
                            columnResizeMode="onEnd"
                            enableColumnOrdering={true}
                            enableRowSelection={false}
                            muiTableHeadCellProps={{
                                className: "myHeaderSelectAll",
                            }}
                            enableHiding={true}
                            displayColumnDefOptions={{
                                "mrt-row-select": { visibleInShowHideMenu: false },
                            }}
                            //manualPagination={true}
                            manualFiltering={false}
                            rowCount={data.length}
                            state={{
                                pagination: pagination,
                            }}
                            onPaginationChange={setPagination}
                            muiTableContainerProps={{
                                className: "MaterialTableJs myTableContainer",
                                sx: {
                                    maxHeight: "100%",
                                    overflowX: "auto",
                                },
                            }}
                            muiTableHeadProps={{
                                className: "myHeader",
                                sx: {
                                    display: "table-header-group",
                                },
                            }}
                            renderTopToolbarCustomActions={({ table }) => (
                                <div>
                                    <h5 style={{ margin: 0 }}>
                                        {data.length} NVRs/DVRs discovered
                                    </h5>
                                </div>
                            )}
                        /> */}
                        <MaterialReactTable
                            columns={columns}
                            data={data}
                            enableGlobalFilter={true}
                            enableColumnFilters={false}
                            enableStickyHeader
                            enableColumnResizing={true}
                            globalFilterFn="contains"
                            columnResizeMode="onEnd"
                            enableColumnOrdering={true}
                            enableRowSelection={false}
                            checkboxSelection={true}
                            enableBottomToolbar={true}
                            initialState={{ density: "comfortable" }}
                            muiTableHeadCellProps={{
                                className: "myHeaderSelectAll",
                                sx: {
                                    backgroundColor: "#1976d2",
                                    color: "white",
                                    fontWeight: "bold",
                                },
                            }}
                            muiTableContainerProps={{
                                className: "MaterialTableJs myTableContainer",
                            }}
                            enableHiding={true}
                            displayColumnDefOptions={{
                                "mrt-row-select": { visibleInShowHideMenu: false },
                            }}
                            manualFiltering={false}
                            rowCount={data.length}
                            state={{
                                pagination: pagination,
                            }}
                            onPaginationChange={setPagination}
                            muiTableHeadProps={{
                                className: "myHeader",
                                sx: {
                                    display: "table-header-group",
                                },
                            }}
                            renderTopToolbarCustomActions={({ table }) => (
                                <div>
                                    <h5 style={{ margin: 0 }}>
                                        {data.length} NVRs/DVRs discovered
                                    </h5>
                                </div>
                            )}
                        />
                    </div>
                )}
                {/* <div className='mb-2 mt-2'>
                <Button 
                    className='m-1 ConfigBelowButtons' 
                    variant="contained" 
                    disabled={loading}
                    onClick={() => {
                        // setSelectedRow(row.original);
                        setManualOnBoard(true);
                        showModel({});
                    }}
                    // disabled={!filtersApplied}
                    // style={{ 
                    //   cursor: (!filtersApplied) ? 'not-allowed' : 'pointer',
                    // }}
                >
                    Manual Discovery
                </Button>
                </div> */}
            </div>

            {/* Bulk Edit Modal */}
            <Modal
                show={showAdditionalModal}
                onHide={() => onCloseBtn()}
                dialogClassName="DiscoverWidgetModelDiv"
                aria-labelledby="example-custom-modal-styling-title"
            >
                <>
                    <Modal.Header>
                        <Modal.Title id="example-custom-modal-styling-title"
                            title={`Connected to Camera ${selectedRow ? selectedRow.Name : ""} with IP ${selectedRow ? selectedRow.IP : ""} via Onvif`}
                        >
                        {selectedRow ? selectedRow.Name : "Please fill details to fetch data"} -{" "}
                        {selectedRow ? selectedRow.IP : ""}
                        {isEditMode ? " (Edit Mode)" : " (View Mode)"}
                        </Modal.Title>
                        <img
                            src={RemoveIcon}
                            alt="Remove"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                onCloseBtn();
                            }}
                        />
                    </Modal.Header>

                    <Modal.Body style={{paddingBottom:"0px"}}>
                        <form style={{ width: "100%" }}>
                            { (selectedRow === null)  &&
                                <div
                                    style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    }}
                                >
                                    
                                    <div className="inputMainContainer w40dot75rem">
                                    <div className="inputTypeLabelContainer">
                                        <label className="formFieldLabels">
                                        IP Address<span style={{ color: "red" }}> *</span>
                                        </label>
                                        <input
                                        className="inputType"
                                        placeholder="Enter IPAddress"
                                        value={onvifIPAddress}
                                        disabled={deviceInfo ? true : false}
                                        onChange={(e) => setOnvifIPAddress(e.target.value)}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}>
                                        <span> {onVifIPAddressError} </span>
                                        </p>
                                    </div>
                                    </div>
                                    <div className="inputMainContainer w40dot75rem ml-4">
                                    <div className="inputTypeLabelContainer">
                                        <label className="formFieldLabels">
                                        Port<span style={{ color: "red" }}> *</span>
                                        </label>
                                        <input
                                        className="inputType"
                                        placeholder="Enter Port*"
                                        //type="password"
                                        value={onvifPort}
                                        disabled={deviceInfo ? true : false}
                                        onChange={(e) => setOnvifPort(e.target.value)}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}>
                                        <span> {onVifPortError} </span>
                                        </p>
                                    </div>
                                    </div>
                                    <div style={{ height: "35px", width: "230px", display: "inline-block" }}></div>
                                </div>
                                }
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    borderBottom: "1px solid #ccc",
                                    paddingBottom: "15px",
                                }}
                            >
                                <div className="inputMainContainer w40dot75rem">
                                    <div className="inputTypeLabelContainer">
                                        <label className="formFieldLabels">
                                            Onvif Username<span style={{ color: "red" }}> *</span>
                                        </label>
                                        <input
                                            className="inputType"
                                            placeholder="Enter Username*"
                                            value={onvifUserName}
                                            disabled={deviceInfo ? true : false}
                                            onChange={(e) => setOnvifUserName(e.target.value)}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}>
                                            <span> {onVifUserNameError} </span>
                                        </p>
                                    </div>
                                </div>
                                <div className="inputMainContainer w40dot75rem ml-4">
                                    <div className="inputTypeLabelContainer">
                                        <label className="formFieldLabels">
                                            Onvif Password<span style={{ color: "red" }}> *</span>
                                        </label>
                                        <input
                                            className="inputType"
                                            placeholder="Enter Password*"
                                            // type="password"
                                            value={onvifPassword}
                                            disabled={deviceInfo ? true : false}
                                            onChange={(e) => setOnvifPassword(e.target.value)}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}>
                                            <span> {onVifPasswordError} </span>
                                        </p>
                                    </div>
                                </div>
                                <Button
                                    className="ml-4"
                                    variant="contained"
                                    color="primary"
                                    size="medium"
                                    style={{ height: "35px", width: "130px" }}
                                    onClick={onSubmitBtn}
                                    disabled={deviceInfoLoading ? true : false}
                                >
                                    Submit
                                </Button>
                            </div>
                            {/* <div style={{ width: "100%", padding: "20px", textAlign: "center" }}>
                    <AlertTemplateMessage
                    message={ "Please add username and password to load interface additional data."}
                    />
                </div> */}
                        </form>
                        <div
                            className="DiscoverFormAdditionForm border-top-0"
                            style={{ height: "520px", overflowY: "auto" }}
                        >
                            {
                                deviceInfoLoading ? (
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        minHeight="300px"
                                    >
                                        <CircularProgress />
                                    </Box>
                                ) : !deviceInfo ? (
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        minHeight="300px"
                                    >
                                        <Typography color="textSecondary">
                                            Please enter credentials and submit to fetch device information.
                                        </Typography>
                                    </Box>
                                ) : (
                                    <div className="device-info-container">
                                        {/* Header */}
                                        {/* <div className="device-header">
                                            <div className="header-left">
                                                <VideocamIcon sx={{ color: "#1976d2", mr: 1 }} />
                                                <span className="title">
                                                    Device Information – {selectedDeviceIP}
                                                </span>
                                            </div>

                                            <div className="header-right connected">
                                                <CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} />
                                                Connected
                                            </div>
                                        </div> */}

                                        {/* Sub Header */}
                                        {/* <div className="sub-header">
                                            <span>Manufacturer: {deviceInfo?.Manufacturer || "N/A"}</span>
                                            <span>Last Sync: {new Date().toLocaleDateString()}</span>
                                        </div> */}

                                        {/* ONVIF Status */}
                                        {/* {
                                            deviceInfo?.Profiles && (
                                                <div className="section">
                                                    <div className="section-title">
                                                        <CheckCircleIcon sx={{ color: "#2e7d32", mr: 1 }} />
                                                        Onvif Connection Status
                                                    </div>
                                                    <div className="section-body">
                                                        <p>Connected successfully via Onvif</p>
                                                        <p>
                                                            Profiles detected: <strong>{Array.isArray(deviceInfo?.Profiles) ? deviceInfo?.Profiles.join(", ") : deviceInfo?.Profiles}</strong>
                                                        </p>
                                                    </div>
                                                </div>
                                            )
                                        } */}


                                        {/* Device Overview */}
                                        <div className="section">
                                            <div className="section-title">
                                                <ListAltIcon sx={{ color: "#455a64", mr: 1 }} />
                                                Device Overview
                                            </div>

                                            <div className="info-box">
                                                <div className="info-row">
                                                    <span className="label">
                                                        Device Name
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="value"
                                                        value={deviceName}
                                                        onChange={(e) => setDeviceName(e.target.value)}
                                                        style={{
                                                            border: `${deviceName ? "1px solid #ccc" : "1px solid red"}`,
                                                            padding: '2px 4px',
                                                            borderRadius: '2px',
                                                            width: "auto",
                                                            maxWidth: "50%",
                                                            background: 'transparent',
                                                            textAlign: "right",
                                                        }}
                                                    />
                                                </div>
                                                <div className="info-row">
                                                    <span className="label">System</span>
                                                    <span className="value">CCTV</span>
                                                </div>
                                                <div className="info-row">
                                                    <span className="label">Brand</span>
                                                    <select
                                                        value={selectedBrand}
                                                        disabled={isEditMode}
                                                        onChange={(e) => setSelectedBrand(e.target.value)}
                                                        style={{
                                                            width: "18%",
                                                            padding: "8px 10px",
                                                            //border: "1px solid #ccc",
                                                            border: `${selectedBrand ? "1px solid #ccc" : "1px solid red"}`,
                                                            borderRadius: "4px",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        {Array.isArray(interfaceSubTypeData) &&
                                                            interfaceSubTypeData.map((item) => (
                                                                <option
                                                                    key={item.InterfacesubtypeId}
                                                                    value={item.InterfacesubtypeId}
                                                                >
                                                                    {item.Interfacesubtypename}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>
                                                <div className="info-row">
                                                    <span className="label">Device Type</span>
                                                    <span className="value">
                                                        {selectedRow?.DeviceType}
                                                    </span>
                                                </div>
                                                <div className="info-row">
                                                    <span className="label">Firmware</span>
                                                    <span className="value">
                                                        {deviceInfo?.Firmware || "Not Available"}
                                                    </span>
                                                </div>


                                                <div className="info-row">
                                                    <span className="label">Serial Number</span>
                                                    <span className="value">
                                                        {deviceInfo?.SerialNumber || "Not Available"}
                                                    </span>
                                                </div>



                                                <div className="info-row">
                                                    <span className="label">Timezone</span>
                                                    {/* <span className="value">
                                                        {deviceInfo?.Timezone || "Not Available"}
                                                    </span> */}

                                                    <select

                                                        value={selectedTimeZone}
                                                        onChange={(e) => setSelectedTimeZone(e.target.value)}
                                                        style={{
                                                            width: "18%",
                                                            padding: "8px 10px",
                                                            //border: "1px solid #ccc",
                                                            border: `${selectedTimeZone ? "1px solid #0b70d1" : "1px solid red"}`,
                                                            borderRadius: "4px",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        {Array.isArray(timezone) &&
                                                            timezone.map((item) => (
                                                                <option
                                                                    key={item.TimeZoneId}
                                                                    value={item.TimeZoneId}
                                                                >
                                                                    {item.Fullname} - {item.Abbreviation}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Network Details */}
                                        <div className="section">
                                            <div className="section-title">
                                                <NetworkCheckIcon sx={{ color: "#0288d1", mr: 1 }} />
                                                Network Details
                                            </div>

                                            <div className="info-box">
                                                <div className="info-row">
                                                    <span className="label">IP Address</span>
                                                    <span className="value" style={{ textAlign: "right" }}>
                                                        {selectedRow?.IP  || onvifIPAddress || "Not Available"}
                                                    </span>
                                                </div>

                                                <div className="info-row">
                                                    <span className="label">HTTP Port</span>
                                                    <span className="value">
                                                        {deviceInfo?.NetworkInfo?.HTTPPort || "Not Available"}
                                                    </span>
                                                </div>

                                                <div className="info-row">
                                                    <span className="label">RTSP Port</span>
                                                    <span className="value">
                                                        {deviceInfo?.NetworkInfo?.RTSPPort || "Not Available"}
                                                    </span>
                                                </div>

                                                <div className="info-row">
                                                    <span className="label">TCP Port</span>
                                                    <input
                                                        type="text"
                                                        className="value"
                                                        value={tcpPort}
                                                        onChange={e => setTcpPort(e.target.value)}
                                                        style={{
                                                            border: `${tcpPort ? "1px solid #0b70d1" : "1px solid red"}`,
                                                            padding: "2px 4px",
                                                            borderRadius: "2px",
                                                            width: "auto",
                                                            maxWidth: "5%",
                                                            background: "transparent",
                                                            textAlign: "right",
                                                        }}
                                                    />
                                                </div>

                                                {/* <div className="info-row">
                                                    <span className="label">MAC Address</span>
                                                    <span className="value">
                                                        {deviceInfo?.NetworkInfo?.MACAddress ||
                                                            "Not Available"}
                                                    </span>
                                                </div> */}
                                            </div>
                                        </div>

                                        {/* Streaming Information */}
                                        {/* <div className="section">
                                            <div className="section-title">
                                                <LiveTvIcon sx={{ color: "#6a1b9a", mr: 1 }} />
                                                Streaming Information
                                            </div>

                                            <div className="info-box">
                                                <div className="info-row">
                                                    <span className="label">Main Stream</span>
                                                    <span className="value">
                                                        rtsp://ip:554/Streaming/101
                                                        <ContentCopyIcon
                                                            sx={{
                                                                fontSize: 16,
                                                                ml: 1,
                                                                cursor: "pointer",
                                                                color: "#1976d2",
                                                            }}
                                                        />
                                                    </span>
                                                </div>

                                                <div className="info-row">
                                                    <span className="label">Sub Stream</span>
                                                    <span className="value">
                                                        rtsp://ip:554/Streaming/102
                                                        <ContentCopyIcon
                                                            sx={{
                                                                fontSize: 16,
                                                                ml: 1,
                                                                cursor: "pointer",
                                                                color: "#1976d2",
                                                            }}
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                        </div> */}

                                        {/* Capabilities */}
                                        <div className="section">
                                            <div className="section-title">
                                                <SettingsIcon sx={{ color: "#f57c00", mr: 1 }} />
                                                Capabilities
                                            </div>

                                            <div className="info-box">
                                                <div className="info-row">
                                                    <span className="label">Profiles</span>
                                                    <span className="value">
                                                        {selectedRow?.Profiles &&
                                                            Array.isArray(selectedRow.Profiles)
                                                            ? selectedRow.Profiles.map(
                                                                (profile) => `[ ${profile} ]`,
                                                            ).join(" ")
                                                            : "Not Available"}
                                                    </span>
                                                </div>

                                                <div className="info-row">
                                                    <span className="label">PTZ</span>
                                                    <span className="value">
                                                        {deviceInfo.Capabilities.PTZ === null || deviceInfo.Capabilities.PTZ === undefined || deviceInfo.Capabilities.PTZ === '' ? (
                                                            <>
                                                                Not Available
                                                            </>
                                                        ) : deviceInfo.Capabilities.PTZ ? (
                                                            <>
                                                                <CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} />
                                                                Supported
                                                            </>
                                                        ) : (
                                                            <>
                                                                <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />
                                                                Not Supported
                                                            </>
                                                        )}
                                                    </span>
                                                </div>
                                                <div className="info-row">
                                                    <span className="label">Events</span>
                                                    <span className="value">
                                                        {deviceInfo.Capabilities.Events === null || deviceInfo.Capabilities.Events === undefined || deviceInfo.Capabilities.Events === '' ? (
                                                            <>
                                                                Not Available
                                                            </>
                                                        ) : deviceInfo.Capabilities.Events ? (
                                                            <>
                                                                <CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} />
                                                                Supported
                                                            </>
                                                        ) : (
                                                            <>
                                                                <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />
                                                                Not Supported
                                                            </>
                                                        )}
                                                    </span>
                                                </div>

                                                <div className="info-row">
                                                    <span className="label">Two Way Audio</span>
                                                    <span className="value">
                                                        {deviceInfo.Capabilities.Audio ? (
                                                            <CheckCircleIcon
                                                                sx={{ color: "#2e7d32", mr: 0.5 }}
                                                            />
                                                        ) : (
                                                            <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />
                                                        )}
                                                        {deviceInfo.Capabilities.Audio
                                                            ? "Supported"
                                                            : "Not Supported"}
                                                    </span>
                                                </div>

                                                <div className="info-row">
                                                    <span className="label">Hooter</span>
                                                    <span className="value">
                                                        {deviceInfo.Capabilities.Relay ? (
                                                            <CheckCircleIcon
                                                                sx={{ color: "#2e7d32", mr: 0.5 }}
                                                            />
                                                        ) : (
                                                            <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />
                                                        )}
                                                        {deviceInfo.Capabilities.Relay
                                                            ? "Supported"
                                                            : "Not Supported"}
                                                    </span>
                                                </div>

                                                <div className="info-row">
                                                    <span className="label">Video Analytics</span>
                                                    <span className="value">
                                                        {deviceInfo.Capabilities.VideoAnalytics === null || deviceInfo.Capabilities.VideoAnalytics === undefined || deviceInfo.Capabilities.VideoAnalytics === '' ? (
                                                            <>
                                                                Not Available
                                                            </>
                                                        ) : deviceInfo.Capabilities.VideoAnalytics ? (
                                                            <>
                                                                <CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} />
                                                                Supported
                                                            </>
                                                        ) : (
                                                            <>
                                                                <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />
                                                                Not Supported
                                                            </>
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Communication Settings */}
                                        <div className="section">
                                            <div className="section-title">
                                                <ConnectWithoutContactIcon sx={{ color: "#d11d62", mr: 1 }} />
                                                Communication Settings
                                            </div>


                                            <div className="info-box">
                                                <div className="info-row">
                                                    <span className="label">Interface Username</span>
                                                    <input
                                                        type="text"
                                                        className="value"
                                                        //placeholder="Enter Username"
                                                        value={interfaceUserName}
                                                        onChange={(e) => setInterfaceUserName(e.target.value)}
                                                        style={{
                                                            border: `1px solid #0b70d1`,
                                                            padding: "2px 4px",
                                                            borderRadius: "2px",
                                                            width: "auto",
                                                            maxWidth: "50%",
                                                            background: "transparent",
                                                            textAlign: "right",
                                                        }}
                                                    />
                                                </div>

                                                <div className="info-row">
                                                    <span className="label">Interface Password</span>
                                                    <input
                                                        type="text"
                                                        className="value"
                                                        //placeholder="Enter Password"
                                                        value={interfacePassword}
                                                        onChange={(e) => setInterfacePassword(e.target.value)}
                                                        style={{
                                                            border: `1px solid #0b70d1`,
                                                            padding: "2px 4px",
                                                            borderRadius: "2px",
                                                            width: "auto",
                                                            maxWidth: "50%",
                                                            background: "transparent",
                                                            textAlign: "right",
                                                        }}
                                                    />
                                                </div>

                                                {/* <div className="info-row">
                                                    <span className="label">Two way Communication</span>
                                                    <span className="value" style={{ textAlign: 'right' }}>
                                                        <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px', cursor: 'pointer' }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={isTwoWayEnabled}
                                                                onChange={() => setIsTwoWayEnabled(!isTwoWayEnabled)}
                                                            />
                                                            <span >Enable Two way communication</span>
                                                        </label>
                                                    </span>
                                                </div> */}

                                                {/* <div className="info-row">
                                                    <span className="label">Enable Hooter Type</span>
                                                    <span className="value" style={{ textAlign: 'right' }}>
                                                        <div style={{ display: 'inline-flex', gap: '12px', alignItems: 'center', justifyContent: 'flex-end' }}>
                                                            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isHooterEnabled}
                                                                    onChange={() => {
                                                                        setIsHooterEnabled(!isHooterEnabled)
                                                                    }}
                                                                />
                                                                <span style={{ marginLeft: '8px' }}>Enable Hooter</span>
                                                            </label>

                                                            // <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                            //     <input
                                                            //         type="checkbox"
                                                            //         checked={isExternalHooterEnabled}
                                                            //         onChange={() => {
                                                            //         if (!isExternalHooterEnabled) {
                                                            //             setIsExternalHooterEnabled(true);
                                                            //             setIsInternalHooterEnabled(false);
                                                            //         } else {
                                                            //             setIsExternalHooterEnabled(false);
                                                            //         }
                                                            //         }}
                                                            //         style={{ marginLeft: '0px' }}
                                                            //     />
                                                            //     <span style={{ marginLeft: '8px' }}>External Hooter</span>
                                                            //     </label>
                                                        </div>
                                                    </span>
                                                </div> */}



                                            </div>
                                        </div>


                                        {/* Devices Table */}
                                        <div className="section">
                                            <div className="section-title">
                                                <TableViewRoundedIcon sx={{ color: "#158533", mr: 1 }} />
                                                Devices Details
                                            </div>

                                            <div className="info-box" style={{ padding: 0 }}>
                                                <DeviceDetails devices={devices} setDevices={setDevices} tableFor="nvr/dvr" />
                                            </div>
                                        </div>
                                    </div>
                                )


                            }

                        </div>
                       
                    </Modal.Body>
                    <Modal.Footer>
                         <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "15px",
                            padding: "15px",
                            width: "100%",
                        }}>
                            <div style={{ display: "flex", gap: "15px", flex: 1 }}>
                                {/* Customer Dropdown */}
                                <div style={{ flex: 1 }}>
                                    <label style={{
                                        display: "block",
                                        marginBottom: "5px",
                                        fontWeight: "600",
                                        fontSize: "14px",
                                    }}>
                                        Customer <span style={{ color: "red" }}> *</span>
                                    </label>
                                    <select
                                        value={selectedCustomer}
                                        disabled={!deviceInfo || isEditMode}
                                        onChange={(e) => {
                                            setSelectedCustomer(e.target.value);
                                            setSelectedSite("");
                                            setSiteSearch("");
                                        }}
                                        style={{
                                            width: "100%",
                                            padding: "8px 10px",
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                            fontSize: "14px",
                                            backgroundColor: !deviceInfo ? "#f5f5f5" : "white",
                                        }}
                                    >
                                        <option value="">-- Select Customer --</option>
                                        {customerOptions.map((customer) => (
                                            <option key={customer.id} value={customer.id}>
                                                {customer.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Site Dropdown */}
                                <div style={{ flex: 1 }}>
                                    <label style={{
                                        display: "block",
                                        marginBottom: "5px",
                                        fontWeight: "600",
                                        fontSize: "14px",
                                    }}>
                                        Site <span style={{ color: "red" }}> *</span>
                                    </label>
                                    <select
                                        value={selectedSite}
                                        onChange={(e) => setSelectedSite(e.target.value)}
                                        disabled={!selectedCustomer || siteOptions.length === 0 || isEditMode}
                                        style={{
                                            width: "100%",
                                            padding: "8px 10px",
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                            fontSize: "14px",
                                            backgroundColor: !selectedCustomer || siteOptions.length === 0 ? "#f5f5f5" : "white",
                                        }}
                                    >
                                        <option value="">{siteOptions.length === 0 && selectedCustomer ? "-- No site found --" : "-- Select Site --"}</option>
                                        {siteOptions.map((site) => (
                                            <option key={site.id} value={site.id}>
                                                {site.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Device Onboard Button */}
                            <button
                                className="DataAccessEdit mt-3"
                                onClick={() => {
                                    onBoardDevice();
                                }}
                                disabled={!selectedCustomer || !selectedSite || !deviceInfo}
                                style={{
                                    width: "180px",
                                    height: "35px",
                                    alignSelf: "flex-end",
                                }}
                            >
                                <span className="ViewUpdate">{isEditMode?'Update Device':'Onboard Device'}</span>
                            </button>
                        </div>
                    </Modal.Footer>
                </>
            </Modal>
        </>
    );


}

export default NVRDiscover